export default "__VITE_ASSET__dGSE0WUC__"